import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { iconColors } from '../../icons/Icon';

export const StyledFormLabel = styled.span`
  font-size: 14px;
  color: #9e9e9e;
  padding-left: 5px;
`;

export const FormFieldLabel: React.FC<{ children: ReactNode; required?: boolean }> = ({
  children,
  required = false,
}) => {
  return (
    <>
      <StyledFormLabel>{children}</StyledFormLabel>
      {required && <span style={{ color: iconColors.red, paddingLeft: '5px' }}>*</span>}
    </>
  );
};
